import * as React from 'react';

const SvgToggleList = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 11 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.42432 1.5H1.32644C0.933722 1.5 0.6943 1.93197 0.90244 2.265L5.00032 8.8216C5.19615 9.13494 5.65248 9.13494 5.84832 8.8216L9.94619 2.265C10.1543 1.93197 9.91491 1.5 9.52219 1.5H5.42432Z", fill: "currentColor" }));

export { SvgToggleList as default };
//# sourceMappingURL=toggle-list.svg.js.map
